import { agent } from '../utils/agent'
const API_URL = process.env.REACT_APP_API_URL
const getFixture = async (offset = 0, itemsPerPage = 0, activePage = 0, params = []) => {
  const response = await agent.get(
    `${API_URL}fixtures/listing?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}
const getCompletedFixture = async (offset, itemsPerPage, activePage, params) => {
  const response = await agent.get(
    `${API_URL}fixtures/get-completed-fixture?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}
const saveFixture = async (data) => {
  const response = await agent.post(API_URL + 'fixtures/save-fixture', data)
  return response.data
}
const saveFixtureForLeagueAndIndoor = async (data) => {
  const response = await agent.post(API_URL + 'fixtures/saveFixtureForLeagueAndIndoor', data)
  return response.data
}
const editFixture = async (data) => {
  const response = await agent.post(API_URL + 'fixtures/edit-fixture', data)
  return response.data
}
const getFixtureDetail = async (id, teamId) => {
  const response = await agent.get(`${API_URL}fixtures/fixture-details/${id}/${teamId}`)
  return response.data
}
const getSquadFixture = async (id, teamId) => {
  const response = await agent.get(`${API_URL}fixtures/getSquadFixture`)
  return response.data
}
const getFixtureDetailOld = async (id, teamId) => {
  const response = await agent.get(`${API_URL}fixtures/fixture-details-old/${id}`)
  return response.data
}
const deleteFixture = async (data) => {
  const response = await agent.post(API_URL + 'fixtures/delete-fixture', data)
  return response.data
}
const getActivatedDisplay = async () => {
  const response = await agent.get(API_URL + 'fixtures/get-activated-display')
  return response.data
}

const changeDisplayStatus = async (data) => {
  const response = await agent.post(API_URL + 'fixtures/changeDisplayStatus', data)
  return response.data
}
const getFeedbackManagerList = async (fixtureId) => {
  const response = await agent.get(API_URL + 'fixtures/get-feedback-manager-list/' + fixtureId)
  return response.data
}
const saveAssignedFeedbackManager = async (data) => {
  const response = await agent.post(API_URL + 'fixtures/save-assigned-feedback-manager', data)
  return response.data
}
const deleteAssignedFeedbackManager = async (data) => {
  const response = await agent.post(API_URL + 'fixtures/delete-assigned-feedback-manager', data)
  return response.data
}
const fixtureImport = async (data) => {
  const response = await agent.post(API_URL + 'fixture-import', data)
  return response.data
}
const importFixtureForIndoor = async (data) => {
  const response = await agent.post(API_URL + 'importFixtureForIndoor', data)
  return response.data
}
const getFixtureTeamCount = async (fixtureId) => {
  const response = await agent.get(API_URL + 'fixtures/getFixtureTeamCount')
  return response.data
}

const deleteAllFixture = async (data) => {
  const response = await agent.post(API_URL + 'fixtures/deleteAllFixture', data)
  return response.data
}
const getInProgressFixture = async () => {
  const response = await agent.get(API_URL + 'fixtures/getInProgressFixture')
  return response.data
}
const getFixtureAttributes = async (type) => {
  const response = await agent.get(API_URL + 'fixtures/getFixtureAttributes?type=' + type)
  return response.data
}
const updateAttributeState = async (data) => {
  const response = await agent.post(API_URL + 'fixtures/updateAttributeState', data)
  return response.data
}
const squadPlayerExport = async (data) => {
  try {
    const response = await agent.post(API_URL + 'squadPlayerExport', {
      responseType: 'blob', // Important to handle binary data
    })

    // Create a downloadable link
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'MyClubtap-SquadImport.csv') // Set the file name
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } catch (error) {
    console.error('Error downloading CSV:', error)
  }
}

const importSquadPlayer = async (data) => {
  const response = await agent.post(API_URL + 'importSquadPlayer', data)
  return response.data
}

const FixtureService = {
  getFixture,
  getCompletedFixture,
  saveFixture,
  editFixture,
  getFixtureDetail,
  deleteFixture,
  getActivatedDisplay,
  changeDisplayStatus,
  getFeedbackManagerList,
  saveAssignedFeedbackManager,
  deleteAssignedFeedbackManager,
  fixtureImport,
  importFixtureForIndoor,
  getFixtureTeamCount,
  getFixtureDetailOld,
  getSquadFixture,
  deleteAllFixture,
  getInProgressFixture,
  getFixtureAttributes,
  updateAttributeState,
  squadPlayerExport,
  importSquadPlayer,
  saveFixtureForLeagueAndIndoor,
}

export default FixtureService
